import { useMutation } from "react-query";
import Axios from "axios";
import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";

export function useRemoteFetchVehicleScheduleMutation() {
  return useMutation({
    mutationFn: async (
      bookingScheduleDto: BookingScheduleDto
    ): Promise<BookingScheduleInterface[]> => {
      const { userIds, startDate, endDate } = bookingScheduleDto;
      const { data } = await Axios.get<BookingScheduleInterface[]>("/booking-schedule/vehicle", {
        params: { userIds, startDate, endDate }
      });
      return data;
    }
  });
}
